import { Injectable } from '@angular/core';
import { IPermissionLevel } from '../../models/security/permission-level';
import { ISecurityScreenPermission } from '../../models/security/security-screen-permission';
import { ApiService } from '../data/api.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { observable } from 'rxjs';

interface IPermissionsService {
    permissions: [{ id: string }, ISecurityScreenPermission];
    getPermission(screenName: string): Promise<number>;
    getPermissions(screenName: string): Promise<ISecurityScreenPermission>;
    getCurrentTabPermissionViaState(permissionKey: string, tabKey: string, customPermission: ISecurityScreenPermission): IPermissionLevel
}

@Injectable()
export class PermissionsService implements IPermissionsService {
    permissions: [{ id: string }, ISecurityScreenPermission] = <[{ id: string }, ISecurityScreenPermission]>{};
    public error: any;
    public hasError: boolean;
    constructor(private apiService: ApiService) {
    }
    public getPermission(screenName: string): Promise<number> {
        return this.apiService.get(`api/ScreenPermission/${screenName}`).toPromise()
            .then((response: number) => {
                return response;
            });
    }
    public getPermissions(screenName: string): Promise<ISecurityScreenPermission> {
        return this.apiService.get(`api/ScreenPermission/${screenName}/Permissions`).toPromise()
            .then((response: ISecurityScreenPermission) => {
                return response;
            });
    }
    /*public getPermissionsNoRedirect(screenName: string): Observable<ISecurityScreenPermission> {
        return this.apiService.get<ISecurityScreenPermission>(`api/ScreenPermission/${screenName}/Permissions`, false, undefined, undefined, true).pipe(
            catchError(error => this.handleErrorNoRedirect(error))
        );
    }*/
    public getHasAccess(screenName: string, permissionLevel: IPermissionLevel): Promise<boolean> {
        return this.apiService.get(`api/ScreenPermission/${screenName}/Permissions`).toPromise()
            .then((response: ISecurityScreenPermission) => {
                if (!response || response.screenPermission < permissionLevel)
                    return false;
                else 
                    return true;
            });
    }
    public getCurrentTabPermissionViaState(permissionKey: string, tabKey: string, customPermission: ISecurityScreenPermission = null): IPermissionLevel {
        return 0;
    }
    private handleError(error: Response) {
        this.hasError = true;
        this.error = error;
        return throwError(() => error);
    }
    private handleErrorNoRedirect(error: Response) {
        this.hasError = true;
        this.error = error;
        console.log('noredirect');
        let sec: ISecurityScreenPermission = { id: 0, enabledActions: '', screenPermission: null, tabPermissions: null };
        return new Observable<ISecurityScreenPermission>((observer) => {
            observer.next(sec);
            observer.complete();
        });
    }
}